export default function ReportFooter({ children }) {
  return <div style={{fontStyle: 'italic', textAlign: 'center', margin: '10px'}}>{children}</div>
}